export default __webpack_public_path__ + "static/media/visionsofthesky.fbfd24fa.png";